import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactGuestPicker from '@homeaway/react-guest-picker';
import GuestPickerIcon from '../GuestPickerIcon';
import cnames from 'classnames';
import './style.less';

export default class GuestPicker extends Component {
    static propTypes = {
        edapActionlocationGuestUpdateSubmitted: PropTypes.string,
        isMobile: PropTypes.bool,
        guests: PropTypes.shape({
            adultsCount: PropTypes.number,
            childrenCount: PropTypes.number,
            petIncluded: PropTypes.bool
        }).isRequired,
        onInputGuest: PropTypes.func.isRequired,
        onInputGuestClose: PropTypes.func.isRequired,
        onInputGuestExit: PropTypes.func.isRequired,
        labels: PropTypes.shape({
            label: PropTypes.string,
            adult: PropTypes.string,
            adults: PropTypes.string,
            child: PropTypes.string,
            children: PropTypes.string,
            pets: PropTypes.string,
            guest: PropTypes.string,
            guests: PropTypes.string,
            yesBtn: PropTypes.string,
            noBtn: PropTypes.string,
            applyBtn: PropTypes.string,
            modalTitle: PropTypes.string,
            mobileBtn: PropTypes.string,
            petMessage: PropTypes.string
        }),
        splitDatePicker: PropTypes.bool
    };

    static defaultProps = {
        guests: {
            adultsCount: 0,
            childrenCount: 0,
            petIncluded: false
        },
        id: 'searchbox-guestpicker'
    };

    state = {
        readOnly: false
    };

    handleGuestSelectorChange = (key, value) => {
        this.props.onInputGuest(key, value);
        this.setState({[key]: value});
    };

    handleGuestSelectorOpen = () => {
        this.setState({readOnly: true});
    }

    handleGuestSelectorClose = () => {
        this.setState({readOnly: false});
        this.props.onInputGuestClose();
    }

    handleGuestSelectorExited = (undoState) => {
        this.setState({
            ...undoState,
            readOnly: false
        });

        if (this.props.isMobile) {
            this.props.onInputGuestExit(undoState);
        } else {
            this.props.onInputGuestClose();
        }
    };

    getGuestLabel = (labels, numGuests, pet) => {
        let petString = pet ? `, ${labels.pets}` : '';
        switch (numGuests) {
            case 0:
                return '';

            case 1:
                return `1 ${labels.guest || labels.guests}${petString}`;

            default:
                return `${numGuests} ${labels.guests}${petString}`;
        }
    };

    getLabel = (singularLabel, pluralLabel, count) => (count === 1 ? `${count} ${singularLabel}` : `${count} ${pluralLabel}`);

    render() {
        const {
            isMobile,
            labels,
            isOpen,
            guests: {
                adultsCount,
                childrenCount,
                petIncluded
            },
            splitDatePicker,
            id,
            edapActionlocationGuestUpdateSubmitted
        } = this.props;
        const {readOnly} = this.state;

        let adultsLabel = this.getLabel(labels.adult, labels.adults, adultsCount);
        let childrenLabel = this.getLabel(labels.child, labels.children, childrenCount);

        const formSuffixElement = petIncluded ? labels.petMessage : '';

        const guestPicker = (
            <ReactGuestPicker
                actionLocation={edapActionlocationGuestUpdateSubmitted}
                fadeOutDuration={0}
                label={labels.label}
                name={'Guests'}
                guestLabel={this.getGuestLabel(labels, adultsCount + childrenCount, petIncluded)}
                showPetOption
                formSuffixElement={formSuffixElement}
                onChange={this.handleGuestSelectorChange}
                onExit={this.handleGuestSelectorExited}
                onClose={this.handleGuestSelectorClose}
                onOpen={this.handleGuestSelectorOpen}
                applyButtonLabel={labels.applyBtn}
                clearButtonLabel={''}
                petLabel={labels.pets}
                petYesLabel={labels.yesBtn}
                petNoLabel={labels.noBtn}
                modalTitle={labels.modalTitle}
                continueButtonLabel={labels.mobileBtn}
                inputIcon={<GuestPickerIcon />}
                disableTextInput
                placement="bottom"
                {...{isMobile, adultsLabel, adultsCount, childrenLabel, childrenCount,
                    petIncluded, formSuffixElement, isOpen, readOnly, id}}
            />
        );

        const className = cnames('guest-picker__container', {
            'guest-picker__container--split-dates': splitDatePicker
        });

        return (
            <div className={className}>
                {guestPicker}
            </div>
        );
    }
}
